function SecondPage() {
    return (
        <div className='card'>
            <label className='label'>﴾ About Me ﴿</label>
            <div className='about-me'>
                <span>
                    Hello, my name is Gelff. I am currently developing my skills in programming and 3D modeling, and I intend to pursue a career in game development.
                </span>
                <span>
                    I plan to do an exchange program in Japan by 2028, with the goal of achieving fluency in the Japanese language. I am passionate about Asian culture, especially Japanese culture, and since childhood it has been my dream to visit Japan. My plans also include continuing my academic studies and obtaining permanent residency.
                </span>
                <span>
                    Some of my favorite hobbies are: games, movies, anime, and reading.
                </span>
                <div className='about-me-footer'>
                    <span>Updated on</span>
                    <span>03/23/2026</span>
                    <span>at 21:38</span>
                </div>
            </div>
        </div>
    )
}

export default SecondPage